import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependecy'
import { TemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
  <span class="navheader-text"><slot></slot></span>
`

class NavHeaderText extends HTMLElement {
  constructor() {
      super()
  
      tryLoadDependencies(document, [WebAwesomeComponent.Icon])
  
      const shadow = this.attachShadow({ mode: 'open' })
      shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
      shadow.appendChild(t.content.cloneNode(true))
    }

  connectedCallback() {}
}

customElements.define('ts-navheader-text', NavHeaderText)
